// 30 questions across 6 categories × 5 questions each.
// Server-side QuarterlyCheckIn::AUDIT_CATEGORIES must match keys below.

export const AUDIT_CATEGORIES = [
  { key: "faith", label: "Faith", description: "Your walk with God" },
  { key: "family", label: "Family", description: "Spouse, kids, and household" },
  { key: "physical", label: "Physical Wellness", description: "Body, rest, and health" },
  { key: "financial", label: "Financial", description: "Personal finances and stewardship" },
  { key: "business", label: "Business / Work", description: "Your vocation and calling" },
  { key: "relationships", label: "Relationships / Recreation", description: "Friendships, community, and renewal" },
]

export const AUDIT_QUESTIONS = {
  faith: [
    "I am spending regular time in prayer and Scripture.",
    "I am consistently sharing my faith with others.",
    "I am actively involved in a local church community.",
    "I experience God's presence and direction in my daily life.",
    "I am growing in spiritual disciplines and surrender.",
  ],
  family: [
    "I invest focused, undistracted time with my spouse each week.",
    "I am intentional in raising and discipling my children.",
    "My home feels peaceful and life-giving most of the time.",
    "I communicate openly and listen well with my family.",
    "My family life reflects my stated priorities.",
  ],
  physical: [
    "I exercise consistently and keep my body active.",
    "I eat in a way that energizes rather than drains me.",
    "I am getting enough quality sleep most nights.",
    "I manage stress and take real breaks from work.",
    "I feel physically strong and ready for what each day requires.",
  ],
  financial: [
    "I live on a clear budget and know where my money goes.",
    "I am free from consumer debt (or on a clear plan to be).",
    "I save regularly, including for retirement.",
    "I give generously to the Lord's work.",
    "My financial decisions match my stated values.",
  ],
  business: [
    "My business is producing the results I need and want.",
    "I am using my gifts in my work, not just grinding.",
    "I have clarity on my one-year direction and top priorities.",
    "I am building a team or systems that don't depend only on me.",
    "My work honors God in how it's done, not just what it produces.",
  ],
  relationships: [
    "I have 2–3 close friends I can be fully honest with.",
    "I make time for rest, hobbies, and things that restore me.",
    "I am intentional about community beyond my immediate family.",
    "I show up for others when they need me.",
    "I am known and loved by people who truly know me.",
  ],
}

export const QUESTIONS_PER_CATEGORY = 5

// Positions (0-indexed) within a category's question array that may be left
// blank ("N/A") instead of rated 1-5. Server-side
// QuarterlyCheckIn::OPTIONAL_QUESTION_INDEXES must match this exactly — a
// cross-language test in test/models/quarterly_check_in_test.rb guards
// against drift.
export const AUDIT_OPTIONAL = {
  family: [0, 1],
}
